import { takeLatest, call, fork } from 'redux-saga/effects';
import { BYO_ERRORS_HIDE_EVENT_LEVEL, BYO_ERRORS_CLEAN_ALL } from '../constants';
import { hideEventLevelError, cleanErrors } from '../actions/errors';
export function* hideEventLevelErrorSaga() {
    yield call(hideEventLevelError);
}
export function* cleanErrorsSaga() {
    yield call(cleanErrors);
}
export function* hideEventLevelErrorWatcher() {
    yield takeLatest(BYO_ERRORS_HIDE_EVENT_LEVEL, hideEventLevelErrorSaga);
}
export function* cleanErrorsWatcher() {
    yield takeLatest(BYO_ERRORS_CLEAN_ALL, cleanErrorsSaga);
}
const errorsSagas = [
    fork(hideEventLevelErrorWatcher),
    fork(cleanErrorsWatcher)
];
export default errorsSagas;
